import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import {useTranslation} from "react-i18next";
import ConditionBuilder from "../../Components/ConditionBuilder";


export const EditRule = ({ show, rule, onClose, onSave }: any) => {
    const {t} = useTranslation();
    const [formState, setFormState] = React.useState(rule || {});

    React.useEffect(() => {
        setFormState(rule || {});
    }, [rule]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormState({ ...formState, [name]: value });
    };

    const handleConditionChange = (updatedGroup: any) => {
        setFormState({ ...formState, conditionGroup: updatedGroup });
    };

    const handleSubmit = () => {
        onSave(formState);
    };

    return (
        <Modal show={show} onHide={onClose} backdrop="static" centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{t('RuleList.edit_rule')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('RuleList.rule_name')}</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formState.name || ""}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('RuleList.rule_description')}</Form.Label>
                        <Form.Control
                            type="text"
                            name="description"
                            value={formState.description || ""}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>{t('RuleList.conditions')}</Form.Label>
                        <ConditionBuilder
                            group={formState.conditionGroup || { join: "and", conditions: [] }}
                            onChange={handleConditionChange}
                            t={t}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={onClose}>{t('RuleList.cancel')}</Button>
                <Button variant="primary" onClick={handleSubmit}>{t('RuleList.save')}</Button>
            </Modal.Footer>
        </Modal>
    );
};